import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import Utils from 'src/app/utils';
import { Options } from 'ngx-slider-v2';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

declare var _: any;
declare var $: any;

declare var mapboxgl: any;

@Component({
  selector: 'app-shift',
  templateUrl: './shift.component.html',
  styleUrls: ['./shift.component.scss']
})
export class ShiftComponent implements OnInit {

  shift: any = null;
  shift_id: any = null;
  line: any = null;
  coords: any = [];
  pin: any;
  route_id = "route_";
  popup: any = null;

  id?: number;

  workers: any;
  center: any;
  map: any;
  features: any = [];
  v_features: any = [];
  marker: any;
  markers: any = [];
  v_markers: any = [];

  settings = {
    'vehicles':true,
    'workers':true
  };

  show_all:boolean = false;

  options:any = null;
  step = 0;
  step_location:any = null;
  step_marker:any = null;

  style=localStorage.getItem("map_style") ? localStorage.getItem("map_style") : "streets-v12";

  show_path = localStorage.getItem("show_path") ? localStorage.getItem("show_path")=="show" : true;

  getDateFromString = Utils.getDateFromString;

  // @ViewChild('shiftExport',{static:false}) shiftExport: ElementRef;
  
  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public shiftExport: ElementRef) { }

  ngOnInit(): void {

    this.shift_id = +this.route.snapshot.params['id'];

    //console.log('id',this.shift_id);

    this.getShift();

  }

  getShift(){

    this.okService.get("shifts/"+this.shift_id,{'show_all': this.show_all,'expand':'pins,locations'})
    .subscribe((data) => {

      this.shift = data.body;

      //console.log("Shift",this.shift);

      this.processShift();

    });
  }

  changeLocation(){

    this.step_location = this.shift.locations[this.step];

    let color = "#25477b";

    if(this.step_marker){
      this.step_marker.remove();
    }

    this.step_marker = new mapboxgl.Marker({"color":color})
    .setLngLat([this.step_location.lng, this.step_location.lat])
    .setPopup(new mapboxgl.Popup({ offset: 25 }) // add popups
    .setHTML('<p>Worker Location at '+this.step_location.time+'</p>'))
    .addTo(this.map);

  }

  processShift(){


    //console.log("this.shift");
    //console.log(this.shift);


    if(this.shift.locations && this.shift.locations.length > 2){

        let center = this.shift.locations[0];

        this.options = {
          steps: this.shift.locations.length-1,
          floor: 0,
          ceil: this.shift.locations.length-1,
          hidePointerLabels: true,
          hideLimitLabels: true
        }
        if(this.shift.status != "Shift Completed"){
          this.step = this.shift.locations.length-1;
        }

        mapboxgl.accessToken = 'pk.eyJ1IjoidHJ1c3R5b3giLCJhIjoiY2wxY2Y0emQ1MDcwOTNwcDNxYTd3ODB1ZyJ9.moSeRr49cY5d14hosZeT1w';
        this.map = new mapboxgl.Map({
            container: 'shift_map',
            style: 'mapbox://styles/mapbox/'+this.style,
            center: [center.lng,center.lat],
            zoom: 10,
            options: true,
            preserveDrawingBuffer: true
        });

        if(this.shift.pins.length > 0){
          for (let i = 0; i < this.shift.pins.length; i++) {

            let pin = this.shift.pins[i];
            if(pin.lat && pin.lng){
              this.addMarker(pin);
            }


          }
        }

        if(this.show_path){

          if(this.shift.type == "gps-high"){


            let points:any = [];
            for (let i = 0; i < this.shift.locations.length; i++) {
              points.push([this.shift.locations[i].lng,this.shift.locations[i].lat])
            }
            //console.log(points);
            let _this = this;
            this.map.on('load', function () {
              _this.map.addSource('route', {
              'type': 'geojson',
              'data': {
              'type': 'Feature',
              'properties': {},
              'geometry': {
              'type': 'LineString',
              'coordinates': points
              }
              }
              });
              _this.map.addLayer({
              'id': 'route',
              'type': 'line',
              'source': 'route',
              'layout': {
                  'line-join': 'round',
                  'line-cap': 'round'
              },
              'paint': {
                  'line-color': '#fb8a01',
                  'line-width': 5,
                  'line-opacity': 0.7
              }});
            });

          }else{

              for (let i = 0; i < this.shift.locations.length; i++) {

                var el = document.createElement('div');
                el.innerHTML = String(i+1);
                el.classList.add('marker-shift');


                var marker = new mapboxgl.Marker(el)
                .setLngLat([this.shift.locations[i].lng,this.shift.locations[i].lat])
                .setPopup(new mapboxgl.Popup().setHTML("Location at "+this.shift.locations[i].time))
                .addTo(this.map);


              }

          }
        }

        this.changeLocation();

    }
  }

  resetPopup(){

    if(this.popup){
      this.popup.remove();
    }

    this.popup = new mapboxgl.Popup({
      closeButton: true,
      closeOnClick: true
    });
  }

  viewPin(pin:any){

    //console.log(pin);

    if(pin.lat){

      this.map.setCenter([pin.lng, pin.lat]);
      this.addPopup(pin);
      this.addMarker(pin);

    }

    $('html, body').animate({
      scrollTop: $("#shift_map").offset().top
    }, 1000);

  }

  getTitle(pin:any){

    let title = "";
    if(pin.status == "ok"){
      title = "Check In at "+pin.created_at_str;
    }else if(pin.status == "start"){
      title = "Started shift at "+pin.created_at_str;
    }else if(pin.status == "end"){
      title = "Ended shift at "+pin.created_at_str;
    }else if(pin.status == "help"){
      title = "Requested Help at "+pin.created_at_str;
    }else if(pin.status == "missed"){
      title = "Missed Check In Alert Sent at "+pin.created_at_str;
    }else if(pin.status == "mandown"){
      title = "Man Down Alert Sent at "+pin.created_at_str;
    }

    return title;

  }

  markerColor(pin:any){
    let color = "#f7921e";

   if(pin.type=="started_the_shift"){
      color = '#58d300';
   }else if(pin.type=="sent_help_signal"){
      color = '#d3001c';
   }else if(pin.type=="monitors_alerted"){
      color = '#ff7338';
   }else if(pin.type=="man_down_alert"){
      color = '#ff7338';
   }else if(pin.type=="worker_is_overdue"){
      color = '#f78c00';
   }else if(pin.type=="checked_in"){
      color = '#f7e200';
   }else if(pin.type=="ended_the_shift"){
      color = '#000000';
   }else if(pin.type=="worker_outside_safety_zone"){
      color = '#5600f7';
   }else{
      color = '#ffffff';
   }


    return color;
  }

  addMarker(pin:any){


    let color = this.markerColor(pin);


    var marker = new mapboxgl.Marker({"color":color})
    .setLngLat([pin.lng, pin.lat])
    .setPopup(new mapboxgl.Popup({ offset: 25 }) // add popups
    .setHTML('<p>'+pin.title+'</p>'))
    .addTo(this.map);

  }

  addPopup(pin:any){

    this.resetPopup();

    this.popup.setLngLat([parseFloat(pin.lng), (parseFloat(pin.lat))])
      .setHTML('<p>'+pin.title+'</p>')
      .addTo(this.map);
  }

  changeStyle(style:string){
    //console.log(style);

    this.style = style;

    localStorage.setItem("map_style",style)

    this.map.setStyle('mapbox://styles/mapbox/' + style);
  }

  togglePath(){
    this.show_path = !this.show_path;
    localStorage.setItem("show_path",this.show_path ? 'show' : 'hide')
    this.processShift();
  }

  // public exportShift(): void {
  //   const width = this.shiftExport.nativeElement.clientWidth;
  //   const height = this.shiftExport.nativeElement.clientHeight + 40;
  //   let orientation = '';
  //   let imageUnit = 'pt';

  //   if(width > height){
  //     orientation = 'l';
  //   }else{
  //     orientation = 'p';
  //   }

  //   domtoimage
  //   .toPng(this.shiftExport.nativeElement, {
  //     width: width,
  //     height: height
  //   })
  //   .then(function (result:any) {
  //     let jsPdfOptions = {
  //     orientation: orientation,
  //     unit: imageUnit,
  //     format: [width + 50, height + 220]
  //   };
  //   const pdf = new jsPDF('p','mm',[width+50,height+220]);
  //   // const pdf = new jsPDF(options:jsPdfOptions | '');
  //   pdf.addImage(result, 'PNG', 25, 185, width, height);
  //   pdf.save('shift_export'+ '.pdf');
  //   })
  //   .catch(function (error:any) {
  //     console.error('Error: sorry, something went wrong')
  //   });
  //   }

  exportShift(){
    const data = document.getElementById("shift-export");
    console.log('export shift');
    if(data){
      // let context = data.getContext('webgl', { preserveDrawingBuffer: true });
      html2canvas(data).then(canvas => {
        console.log('html2canvas');
        const imgWidth = 208;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const contentData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p','mm','a4');
        const position = 0;
        pdf.addImage(contentData,'PNG',0,position,imgWidth,imgHeight);
        pdf.save('shift-export');
      })
    }
  }

}
